class FlavorSlider extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-flavor-tab]'));
    this.slides = Array.from(this.querySelectorAll('[data-flavor-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-flavor-dot]'));
    this.nextButton = this.querySelector('[data-flavor-next]');
    this.activeIndex = Math.max(0, this.tabs.findIndex((tab) => tab.classList.contains('is-active')));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.show(index, true));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.show(index));
    });

    this.nextButton?.addEventListener('click', () => this.show(this.activeIndex + 1));

    this.addEventListener('pointerdown', (event) => {
      this.pointerStart = event.clientX;
    });
    this.addEventListener('pointerup', (event) => this.onSwipe(event));
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    if (window.Shopify?.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.indexOf(event.target);
        if (index >= 0) this.show(index, false);
      });
    }

    this.show(this.activeIndex);
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  show(index, focusTab = false) {
    if (!this.slides.length) return;

    const nextIndex = (index + this.slides.length) % this.slides.length;
    this.activeIndex = nextIndex;
    this.style.setProperty('--active-slide-text', getComputedStyle(this.slides[nextIndex]).getPropertyValue('--slide-text'));
    this.style.setProperty('--active-slide-background', getComputedStyle(this.slides[nextIndex]).getPropertyValue('--slide-background'));
    this.style.setProperty('--active-slide-accent', getComputedStyle(this.slides[nextIndex]).getPropertyValue('--slide-button-background'));

    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === nextIndex;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === nextIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });

    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === nextIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.toggleAttribute('inert', !active);
    });

    if (focusTab) this.tabs[nextIndex]?.focus({ preventScroll: true });
    this.startAutoplay();
  }

  onKeydown(event, index) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();

    if (event.key === 'Home') return this.show(0, true);
    if (event.key === 'End') return this.show(this.tabs.length - 1, true);
    this.show(index + (event.key === 'ArrowRight' ? 1 : -1), true);
  }

  onSwipe(event) {
    if (this.pointerStart == null || event.pointerType === 'mouse') return;
    const distance = event.clientX - this.pointerStart;
    this.pointerStart = null;
    if (Math.abs(distance) < 50) return;
    this.show(this.activeIndex + (distance < 0 ? 1 : -1));
  }

  startAutoplay() {
    this.stopAutoplay();
    if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
    const delay = Number(this.dataset.autoplayDelay) || 5000;
    this.autoplayTimer = window.setInterval(() => this.show(this.activeIndex + 1), delay);
  }

  stopAutoplay() {
    window.clearInterval(this.autoplayTimer);
  }
}

if (!customElements.get('flavor-slider')) {
  customElements.define('flavor-slider', FlavorSlider);
}
